import { render, staticRenderFns } from "./CustomerDocumentsWidget.vue?vue&type=template&id=83b92244&scoped=true&"
import script from "./CustomerDocumentsWidget.vue?vue&type=script&lang=js&"
export * from "./CustomerDocumentsWidget.vue?vue&type=script&lang=js&"
import style0 from "./CustomerDocumentsWidget.vue?vue&type=style&index=0&id=83b92244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83b92244",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\Mobaxe\\Betterway.vms\\Betterway.VMS.web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('83b92244')) {
      api.createRecord('83b92244', component.options)
    } else {
      api.reload('83b92244', component.options)
    }
    module.hot.accept("./CustomerDocumentsWidget.vue?vue&type=template&id=83b92244&scoped=true&", function () {
      api.rerender('83b92244', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Widgets/CustomerDocumentsWidget.vue"
export default component.exports